const model = {
    submitting: false,
    errors: null,
    orderIn: [],
    success: false,
    productPriceDetails: [],

    allProducts: [],

    // in case of using barcode
    units: [],
    barcodeProducts: [],
};

export default model;
